/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DomainDto } from '../models/DomainDto';
import type { DomainFilterResponseDto } from '../models/DomainFilterResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DomainControllerService {

    /**
     * @param healthStatus
     * @param from
     * @param status
     * @param limit
     * @param name
     * @param storageType
     * @returns DomainFilterResponseDto OK
     * @throws ApiError
     */
    public static listDomains(
        healthStatus?: boolean,
        from?: number,
        status?: 'COMPLETED' | 'PENDING' | 'RUNNING',
        limit?: number,
        name?: string,
        storageType?: 'Memory' | 'Postgres' | 'Shared Postgres' | 'External',
    ): CancelablePromise<DomainFilterResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domains',
            query: {
                'healthStatus': healthStatus,
                'from': from,
                'status': status,
                'limit': limit,
                'name': name,
                'storageType': storageType,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateDomain(
        requestBody: DomainDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/domains',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns DomainDto Created
     * @throws ApiError
     */
    public static createDomain(
        requestBody: DomainDto,
    ): CancelablePromise<DomainDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/domains',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns DomainDto OK
     * @throws ApiError
     */
    public static getDomain(
        name: string,
    ): CancelablePromise<DomainDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/domains/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteDomain(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/domains/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
